<template>
  <Tabs id="editTabPanel" type="card" v-model="defaultProject" v-if="showTabs.length > 0">
    <TabPane label="体检套餐" name="physicalPackage" v-if="showTabs.indexOf('physicalPackage') > -1" v-loading="loading">
      <el-input placeholder="输入关键字进行过滤" v-model="filterPackageText" clearable style="width: 50%"/>

      <FormItem :label-width="0" prop="packagesIds" :style="{'max-height': '350px', 'overflow-y': 'auto'}">
        <el-tree ref="packagesTree" :data="physicalPackages"  :filter-node-method="filterNode"
          show-checkbox node-key="id" :default-checked-keys="[]"
          @check-change="packagesIdsCheck" :props="defaultProps">
        </el-tree>
      </FormItem>
    </TabPane>

    <TabPane label="体检数据" name="physicalField" v-if="showTabs.indexOf('physicalField') > -1" v-loading="loading">
      <el-input placeholder="输入关键字进行过滤" v-model="filterFieldText" clearable style="width: 50%"/>

      <FormItem :label-width="0" prop="fieldIds" :style="{'max-height': '350px', 'overflow-y': 'auto'}">
        <el-tree ref="fieldTree" :data="physicalFields" :filter-node-method="filterNode"
          show-checkbox :check-strictly="true" :highlight-current="true" :expand-on-click-node="false" node-key="id" :default-checked-keys="[]"
          @check-change="fieldIdsCheck" :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <!--
            <span>{{ node.label }}</span>
            <span :style="{'color': convertBusinessType(data.businessType).color}" v-if="data.businessType">{{ convertBusinessType(data.businessType).name }}</span>
            -->

            <div class="custom-tree-node-content">{{ node.label }}
              <span :style="{'color': convertBusinessType(data.businessType).color}" v-if="data.businessType">--{{ convertBusinessType(data.businessType).name }}</span>
            </div>

          </span>
        </el-tree>
      </FormItem>

    </TabPane>
  </Tabs>
</template>
<script>
import {mixins} from "@/mixins/index.js";

export default {
  name: "EditTabPanel",
  mixins: [mixins],
  data() {
    return {
      defaultProject: '',
      loading:false,
      search: {
        text: "",
        type: ""
      },
      filterPackageText:"",
      filterFieldText:"",
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      physicalPackages: [],
      physicalFields: []
    }
  },
  props: {
    showTabs: {
      type: Array,
      default: () => {
        return ['physicalPackage', 'physicalField'];
      }
    },
    packagesIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    fieldIds: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    filterPackageText(val) {
      this.$refs.packagesTree.filter(val);
    },
    filterFieldText(val) {
      this.$refs.fieldTree.filter(val);
    },
    packagesIds:{
      handler(newVal){
        if (newVal){
          this.$refs.packagesTree.setCheckedKeys(newVal);
        }else {
          this.$refs.packagesTree.setCheckedKeys([]);
        }
      }
    },
    fieldIds:{
      handler(newVal){
        if (newVal){
          this.$refs.fieldTree.setCheckedKeys(newVal);
        }else {
          this.$refs.fieldTree.setCheckedKeys([]);
        }
      }
    }
  },
  mounted() {
    this.defaultProject = this.$props.showTabs[0];
    this.physicalPackages = [];
    this.physicalFields = [];
    if (this.$userSession.checkInstitutionId()) {
      this.packages();
      this.fields();
    }
  },
  computed: {},
  methods: {
    convertBusinessType(businessType){
      if(businessType == 1){
        return {color:'#16B94E',name:"通用"};
      }else if(businessType == 2){
        return {color:'#BDAE0C',name:"幼儿园"};
      }else if(businessType == 3){
        return {color:'#BF7007',name:"小学"}
      }else if(businessType == 4){
        return {color:'#006DFD',name:"中学"}
      }else if(businessType == 5){
        return {color:'#CE1616',name:"大学"};
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    packagesIdsCheck(){
      this.$nextTick(()=>{
        let temp = [];
        this.$refs['packagesTree'].getHalfCheckedKeys().forEach(item=>{
          temp.push(item)
        });

        this.$refs['packagesTree'].getCheckedNodes().forEach(item=>{
          temp.push(item.id)
        });
        this.$emit("on-packagesIds", temp);
      })
    },
    fieldIdsCheck(){
      this.$nextTick(()=>{
        let temp = [];
        this.$refs['fieldTree'].getHalfCheckedKeys().forEach(item=>{
          temp.push(item)
        });

        this.$refs['fieldTree'].getCheckedNodes().forEach(item=>{
          if(item.pid === 0 || item.pid === "0"){
            temp.push(item.id)
          }
        });
        this.$emit("on-fieldIds", temp);
      })
    },
    async packages() {
      this.loading=true;
      this.physicalPackages = await this.applyPackagesName();

      let tempKeys = []
      if(this.physicalPackages&&this.physicalPackages.length>0){
        let count = 1;
        this.physicalPackages.forEach(item =>{
          item.id = item.value;
          tempKeys.push(count);
          if (item.children && item.children.length > 0){
            item.children.forEach(subItem =>{
              subItem.id = subItem.value;
              if (subItem.children && subItem.children.length >0){
                subItem.children.forEach(second => {
                  second.id = second.value;
                  if (second.children && second.children.length >0) {
                    second.children.forEach(three => {
                      three.id = three.value;
                    })
                  }
                })
              }
            })
          }
          count ++;
        })
      }
      this.defaultProps.expandedKeys = tempKeys;

      this.loading=false;
      this.$forceUpdate()
      return this.physicalPackages
    },
    async fields() {
      this.loading=true;
      this.physicalFields = await this.applyFieldConfigList();
      let tempKeys = []
      if(this.physicalFields&&this.physicalFields.length>0){
        let count = 1;
        this.physicalFields.forEach(item =>{
          item.id = item.value;
          item.label = item.label + (item.label != item.alias ? "[" + item.alias + "]" : "");
          tempKeys.push(count);
          if (item.children && item.children.length > 0){
            item.children.forEach(subItem =>{
              subItem.id = subItem.value;
              if (subItem.children && subItem.children.length >0){
                subItem.children.forEach(second => {
                  second.id = second.value;
                  if (second.children && second.children.length >0) {
                    second.children.forEach(three => {
                      three.id = three.value;
                    })
                  }
                })
              }
            })
          }
          count ++;
        })
      }
      this.defaultProps.expandedKeys = tempKeys;

      this.loading=false;
      this.$forceUpdate()
      return this.physicalFields
    }
  }
};
</script>
<style lang="postcss" scoped>
#editTabPanel {min-height: 300px;}

/deep/ .el-tree-node__content>.el-tree-node__expand-icon {padding: 0px;}
/deep/ .el-input__inner {height: 35px;line-height: 35px;}
/deep/ .el-input__icon{line-height: 35px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
.custom-tree-node {flex: 1;display: flex;align-items: center;justify-content: space-between;font-size: 14px;padding-right: 1px;}

</style>
